import createUseStyles from '@eduzz/houston-styles/createUseStyles';

export const useStyles = createUseStyles(() => ({
  closeIcon: {
    float: 'right',
  },
  dialogActions: {
    padding: '16px 24px',
  },
}));
